import React from 'react';
import { Loader2, Search, RefreshCw, Zap, Bell, Settings, FlaskConical, BarChart3, FileText } from 'lucide-react';

export const RoleToolbar = ({
  rolesCount,
  focusMyTime, onToggleFocus,
  rescoring, onRescoreAll,
  detectingRoles, onDetectBatch,
  rolesLoading, onRefresh,
  showAlertSettings, onToggleAlertSettings,
  showScoringConfig, onToggleScoringConfig,
  onOpenSimulator,
  showPatterns, onTogglePatterns,
  showPlaybooks, onTogglePlaybooks,
}) => {
  return (
    <div className="flex items-center justify-between mb-4" data-testid="roles-controls">
      <div className="flex items-center gap-3">
        <h3 className="text-sm font-bold text-[#0A1F44]">Detected Roles ({rolesCount})</h3>
        <button onClick={onToggleFocus}
          className={`px-3 py-1.5 text-[10px] font-bold rounded-lg flex items-center gap-1.5 transition-all ${focusMyTime ? 'bg-[#D4AF37] text-[#0A1F44] shadow-sm ring-1 ring-[#D4AF37]/50' : 'bg-white text-gray-500 border border-gray-300 hover:border-[#D4AF37]'}`}
          data-testid="focus-my-time-btn">
          <Zap className="h-3 w-3" />
          Focus My Time
        </button>
      </div>
      <div className="flex items-center gap-2">
        <button onClick={onRescoreAll} disabled={rescoring}
          className="px-3 py-1.5 bg-white text-gray-600 text-xs font-medium rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 flex items-center gap-1.5"
          data-testid="rescore-all-btn">
          {rescoring ? <Loader2 className="h-3 w-3 animate-spin" /> : <RefreshCw className="h-3 w-3" />}
          Re-Score All
        </button>
        <button onClick={onDetectBatch} disabled={detectingRoles === '_batch'}
          className="px-4 py-2 bg-[#0A1F44] text-white text-xs font-medium rounded-lg hover:bg-[#0d2a5c] disabled:opacity-50 flex items-center gap-1.5"
          data-testid="detect-batch-btn">
          {detectingRoles === '_batch' ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Search className="h-3.5 w-3.5" />}
          Scan All Companies
        </button>
        <button onClick={onRefresh}
          className="p-2 hover:bg-gray-100 rounded-lg" data-testid="refresh-roles-btn">
          <RefreshCw className={`h-3.5 w-3.5 text-gray-400 ${rolesLoading ? 'animate-spin' : ''}`} />
        </button>
        <button onClick={onToggleAlertSettings}
          className={`p-2 rounded-lg transition-all ${showAlertSettings ? 'bg-[#0A1F44] text-white' : 'hover:bg-gray-100 text-gray-400'}`}
          data-testid="alert-settings-btn" title="Pipeline Alert Settings">
          <Bell className="h-3.5 w-3.5" />
        </button>
        <button onClick={onToggleScoringConfig}
          className={`p-2 rounded-lg transition-all ${showScoringConfig ? 'bg-[#D4AF37] text-[#0A1F44]' : 'hover:bg-gray-100 text-gray-400'}`}
          data-testid="scoring-config-btn" title="Scoring Weights Configuration">
          <Settings className="h-3.5 w-3.5" />
        </button>
        <button onClick={onOpenSimulator}
          className="px-3 py-1.5 bg-gradient-to-r from-[#D4AF37] to-[#C4A030] text-[#0A1F44] text-[10px] font-bold rounded-lg hover:shadow-md transition-all flex items-center gap-1.5"
          data-testid="score-simulator-btn" title="Score Simulator">
          <FlaskConical className="h-3 w-3" /> Simulator
        </button>
        <button onClick={onTogglePatterns}
          className={`px-3 py-1.5 text-[10px] font-bold rounded-lg transition-all flex items-center gap-1.5 ${showPatterns ? 'bg-[#0A1F44] text-white' : 'border border-[#0A1F44]/20 text-[#0A1F44] hover:bg-[#0A1F44]/5'}`}
          data-testid="cross-role-patterns-btn" title="Cross-Role Patterns">
          <BarChart3 className="h-3 w-3" /> Patterns
        </button>
        <button onClick={onTogglePlaybooks}
          className={`px-3 py-1.5 text-[10px] font-bold rounded-lg transition-all flex items-center gap-1.5 ${showPlaybooks ? 'bg-[#0A1F44] text-white' : 'border border-[#0A1F44]/20 text-[#0A1F44] hover:bg-[#0A1F44]/5'}`}
          data-testid="playbooks-btn" title="Targeting Playbooks">
          <FileText className="h-3 w-3" /> Playbooks
        </button>
      </div>
    </div>
  );
};
